var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMute = function SvgMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 10.5h3.6M1.5 1.275 9.825 9.6M6.9 4.875V1.95A1.35 1.35 0 0 0 4.749.862c-.27.198-.522.504-.522 1.106V2.4M4.2 4.2v1.35a1.35 1.35 0 0 0 2.304.954z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.8 7.778A3.15 3.15 0 0 1 2.4 5.55v-.9m6.3 0V6q0 .279-.05.554M5.55 8.925V10.5"
  })));
};
export default SvgMute;